// test2823
(2823 && 0);
